import { cn } from "@/lib/utils";
import logoLight from "@/assets/iso27001kit-logo-light.png";
import logoDark from "@/assets/iso27001kit-logo-dark.png";

interface BrandLogoProps {
  /** Pixel height of the logo. Width scales automatically. */
  height?: number;
  /** Hide the wordmark and render only the shield icon (visually crops to top). */
  iconOnly?: boolean;
  className?: string;
  /**
   * "light" = white wordmark for dark backgrounds.
   * "dark"  = dark wordmark for light backgrounds.
   * Defaults to "dark".
   */
  variant?: "light" | "dark";
  /** @deprecated kept for backwards compatibility, no longer used. */
  wordmarkColor?: string;
}

/**
 * ISO27001KIT brand logo. Renders the official shield + wordmark image.
 * Pick `variant="light"` on dark backgrounds and `variant="dark"` on light backgrounds.
 */
export const BrandLogo = ({
  height = 48,
  iconOnly = false,
  className,
  variant = "dark",
}: BrandLogoProps) => {
  const src = variant === "light" ? logoLight : logoDark;

  if (iconOnly) {
    // Source image is roughly 70% shield / 30% wordmark; crop to shield.
    return (
      <span
        className={cn("inline-block overflow-hidden shrink-0", className)}
        style={{ height, width: height }}
      >
        <img
          src={src}
          alt="ISO27001KIT logo"
          style={{ height: Math.round(height / 0.7), width: "auto", display: "block" }}
        />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt="ISO27001KIT logo"
      className={cn("block w-auto select-none", className)}
      style={{ height }}
      draggable={false}
    />
  );
};

export default BrandLogo;
